import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

import { FieldInterventionEntity } from '@connect-services/client/sdk/api';
import { FieldInterventionService } from '@connect-services/client/services/field-intervention.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FontAwesomeModule, MatTooltip, TranslocoModule],
    selector: 'app-field-intervention-status',
    styleUrl: './field-intervention-status.component.scss',
    templateUrl: './field-intervention-status.component.html',
})
export class FieldInterventionStatusComponent {
    public readonly disabled = input<boolean>(false);
    public readonly hasTooltip = input<boolean>(true);
    public readonly size = input<number>(1);
    public readonly status = input.required<FieldInterventionEntity.StatusEnum>();

    protected readonly entityStatusesIconsProperties = FieldInterventionService.entityStatusesIconsProperties;
    protected readonly iconSize = computed((): SizeProp => {
        switch (true) {
            case this.size() < 1.5:
                return '2xs';
            case this.size() < 2:
                return 'xs';
            case this.size() < 2.5:
                return 'sm';
            case this.size() < 3:
                return 'lg';
            default:
                return '2xs';
        }
    });

    private readonly translocoService = inject(TranslocoService);

    public getStatusLabel(): string {
        const statusProperties = this.entityStatusesIconsProperties[this.status()];
        if (!statusProperties?.tooltip) {
            return '';
        }

        return this.translocoService.translate(statusProperties.tooltip);
    }
}
